/**
 * @description 系統參數對應 ParamId 用
 */
export enum SysOptParamId {
    EMAIL_NOTIFY_RETURN_EMAIL = 'RETURN_EMAIL',
    EMAIL_NOTIFY_RETURN_FAX = 'RETURN_FAX',
    EMAIL_NOTIFY_CUSTOM_SERVICE = 'CUSTOM_SERVICE',
    EMAIL_NOTIFY_PODELIVER_PAPER = 'PODELIVER_PAPER',
    EMAIL_NOTIFY_PODELIVER_EPAPER = 'PODELIVER_EPAPER',
    DOC_ID_NTAG = 'NTAG',
    DOC_ID_NTA = 'NTA',
    DOC_ID_SPI = 'SPI',
    DOC_ID_MPA = 'MPA',
    DOC_ID_NTD = 'NTD',
    IOS_SWQRC = 'IOS_SWQRC',
    ANDROID_SWQRC = 'ANDROID_SWQRC',
    IOS_SW_URL = 'IOS_SW_URL',
    ANDROID_SW_URL = 'ANDROID_SW_URL',
    POLICY_PERIOD_DEF = 'POLICY_PERIOD_DEF',
    PODELIVER_PAPER = 'PODELIVER_PAPER',
    PODELIVER_EPAPER = 'PODELIVER_EPAPER',
    BGAP = 'BGAP'
}
